const download = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M1.5 9.817V14.5h13V9.817H16V16H0V9.817zM8.762 0v9.127l3.663-3.669 1.009 1.12L8 12 2.577 6.577l1.01-1.119 3.663 3.67V0z"/></svg>',
};

export { download as default };
